import React, { FC, useCallback } from 'react';
import { useDispatch } from 'react-redux';

import type { ThunkDispatchType } from 'app/redux/types';

import type { DictionaryData } from 'app/lang';

import { PickPresetAmount, pickPresetAmount } from '../../actions/stakeTypes';
import TextWithAmountBar from '../TextWithAmountBar';

import dictionary from './MinLimitError.dictionary.json';

// ---

type MinLimitErrorProps = {
  value: number;
  betId?: number;
  label?: DictionaryData;
};

const MinLimitError: FC<MinLimitErrorProps> = ({ betId, value, label }) => {
  const dispatch: ThunkDispatchType<PickPresetAmount> = useDispatch();

  const pickPresentAmountHandler = useCallback(() => {
    dispatch(pickPresetAmount(value, betId));
  }, [value, betId]);

  return (
    <TextWithAmountBar hasError
                       value={value}
                       data-test="entry-minLimitError"
                       label={label || dictionary.defaultLabel}
                       onClick={pickPresentAmountHandler} />
  );
};

export default MinLimitError;
